module.exports = "/assets/1fa7cb5f47615c8bcd291950a3bca506.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TA.png
// module id = 1849
// module chunks = 0